<template>
  <div class="boxallnow">
    <!-- 头部 -->
    <headbox class="headerbox"></headbox>
    <div id="header" class="outerbox onbigimg">
      <div class="innercoreversion contnone">
        <div class="onnameban">
          <div class="title">
            <!-- <h1 class="custom-title">
              <span class="first-three">亿大师品牌连锁智能搭建专业服务商</span>
            </h1> -->
            <img src="../image/textname.png" height="124px" alt="" />
          </div>
          <div class="text">
            <div>
              <img src="../image/duigou.png" width="33px" alt="" />AI驱动：释放无限潜能，推动社会迈向智能化新时代
            </div>
            <div>
              <img
                src="../image/duigou.png"
                width="33px"
                alt=""
              />智慧畅想：引领我们穿越科技的边界，探索无限可能的新世界
            </div>
            <div>
              <img
                src="../image/duigou.png"
                width="33px"
                alt=""
              />一键开店：轻松一键，开启您的财富之旅，店铺快速开业迎宾
            </div>
          </div>
          <div class="boutton" @click="scrollToAnchor">快速体验</div>
        </div>
      </div>
    </div>
    <projectfour id="product" @cahgnactivk="cahgnactivk"></projectfour>
    <Intestorenspection :textall="textall" :active="active"></Intestorenspection>
    <hellow id="IndustrySolutions"></hellow>
    <morehave id="success"></morehave>
    <imgpage></imgpage>
    <havebacker></havebacker>
    <formtable id="about"></formtable>
    <footbox></footbox>
    <div class="staterclass">
      <div class="iosandor" @mouseenter="handleMouseEnter(1)" @mouseleave="handleMouseLeave(1)">
        <img width="20px" height="20px" src="../image/iopenrigeh.png" alt="" />
        <div style="line-height: 24px">联系电话</div>
        <div class="nowconer" v-if="showbox == 1">
          <div class="text">
            <img src="../image/a-ziyuan563.png" alt="" />
            全国咨询热线
          </div>
          <div>19166351697</div>
          <div class="jianttou"></div>
        </div>
      </div>
      <div class="iosandor" style="margin: 10px 0" @mouseenter="handleMouseEnter(2)" @mouseleave="handleMouseLeave(2)">
        <img width="20px" height="20px" src="../image/weixin.png" alt="" />
        <div style="line-height: 24px">微信咨询</div>
        <!-- -->
        <div class="nowconercop" v-if="showbox == 2">
          <div class="text">
            <img src="../image/zhuanyan.png" style="height: 100%" alt="" />
          </div>
          <div class="jianttou"></div>
        </div>
      </div>
      <div class="iosandor" @mouseenter="handleMouseEnter(3)" @mouseleave="handleMouseLeave(3)">
        <img width="20px" height="20px" src="../image/Vector.png" alt="" />
        <div style="line-height: 24px">下载App</div>
        <!--  -->
        <div class="nohavepadd" v-if="showbox == 3">
          <div>
            <vue-qr class="qr-code" :logoSrc="imageUrl" :text="qrCodeUrl" :size="100" />
          </div>
          <div class="jianttou"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headbox from './headbox.vue'
import footbox from './footbox.vue'
import formtable from './formtable.vue'
import projectfour from './projectfour.vue'
import hellow from './HelloWorld.vue'
import Intestorenspection from './Intestorenspection.vue'
import morehave from './morehave.vue'
import imgpage from './imgpage.vue'
import havebacker from './havebacker.vue'
import vueQr from 'vue-qr'
export default {
  name: 'HomeIndex',
  components: {
    headbox,
    projectfour,
    Intestorenspection,
    hellow,
    morehave,
    imgpage,
    havebacker,
    formtable,
    footbox,
    vueQr,
  },
  data() {
    return {
      qrCodeUrl: `https://wy.sd-wh.com.cn/h5/training/#/downpage?down=app`,
      imageUrl: require('../image/logo.png'),
      showbox: '',
      active: 0,
      textall: [
        {
          imageutl: require('../image/img_phone_@2x.png'),
          arrtitle: [
            {
              conten: [
                {
                  title: 'AI巡检、时实巡检、线下巡检',
                },
                {
                  title: '训练中心',
                },
                {
                  title: '客流分析',
                },
                {
                  title: '总部大屏',
                },
                {
                  title: '模范门店招商示例',
                },
              ],
            },
          ],
        },
        {
          imageutl: require('../image/Aigit.png'),
          arrtitle: [
            {
              conten: [
                {
                  title: 'AI进度识别',
                },
                {
                  title: '智能监控',
                },
                {
                  title: '水印相机',
                },
                {
                  title: '系统自动报告',
                },
              ],
            },
            {
              conten: [
                {
                  title: '进度可视化',
                },
                {
                  title: '隐蔽/交店验收',
                },
                {
                  title: '云相册/云资料库',
                },
                {
                  title: '预警推送',
                },
              ],
            },
          ],
        },
        {
          imageutl: require('../image/computer.png'),
          arrtitle: [
            {
              conten: [
                {
                  title: '运营管理',
                },
                {
                  title: '智能设备控制',
                },
                {
                  title: '智慧安防',
                },
              ],
            },
            {
              conten: [
                {
                  title: '智能预警监控',
                },
                {
                  title: '数据融合',
                },
                {
                  title: '大数据及AI能力',
                },
              ],
            },
          ],
        },
        {
          imageutl: require('../image/jiaju.png'),
          arrtitle: [
            {
              conten: [
                {
                  title: 'AI进度识别',
                },
                {
                  title: 'AI自动抓拍',
                },
                {
                  title: 'AI控温',
                },
                {
                  title: 'AI门店无人直播',
                },
              ],
            },
          ],
        },
      ],
    }
  },
  methods: {
    scrollToAnchor() {
      const targetElement = document.getElementById('about')
      targetElement.scrollIntoView({
        behavior: 'smooth', // 平滑滚动
        block: 'start', // 滚动到目标元素顶部
      })
    },
    cahgnactivk(e) {
      this.active = e
      console.log(e)
    },
    handleMouseEnter(e) {
      this.showbox = e
      console.log('鼠标移入', e)
    },
    handleMouseLeave(e) {
      this.showbox = ''
      console.log('鼠标移出', e)
    },
  },
}
</script>

<style lang="less">
html {
  scroll-behavior: smooth;
}
.headerbox {
  z-index: 1000;
  position: sticky;
  top: 0px;
}
.boxallnow {
  position: relative;
}
.onbigimg {
  height: 600px;
  background-image: url(../image/banant.png);
  background-size: cover; /* 背景图铺满盒子 */
  background-position: center; /* 背景图居中 */
  background-repeat: no-repeat; /* 不重复背景图 */
  .contnone {
    height: 100%;
    display: flex;
    color: #fff;
    .onnameban {
      padding: 107px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        .custom-title {
          .first-three:nth-child(3) {
            color: red; /* 改变前3个元素的颜色 */
          }
        }
      }
      .text {
        font-weight: 500;
        font-size: 20px;
        color: #ffffff;
        & > div {
          line-height: 48px;
          display: flex;
          align-items: center;
        }
      }
      .boutton {
        width: 212px;
        height: 56px;
        text-align: center;
        line-height: 56px;
        background: #57cc9a;
        border-radius: 37px 37px 37px 37px;
      }
    }
  }
}
.staterclass {
  z-index: 100000;
  position: fixed;
  right: 0;
  top: 424px;
  & > div {
    width: 63px;
    height: 63px;
    background: #ffffff;
    border-radius: 7px 7px 7px 7px;
    font-weight: 500;
    font-size: 12px;
    color: #333333;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 7px 7px 7px 7px;
    border: 1px solid #ffffff;
  }
  .iosandor {
    position: relative;
    .nowconer {
      position: absolute;
      left: -127px;
      top: -1px;
      background: #fff;
      border-radius: 4px 4px 4px 4px;
      padding: 14px 16px 14px 14px;
      // font-weight: 500;
      // font-size: 12px;
      // color: #333333;

      .text {
        margin-bottom: 7px;
      }
      .jianttou {
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-left: 8px solid #fff; /* 黑色箭头 */
        // background: #57cc9a;
        position: absolute;
        right: -8px;
        bottom: 17px;
      }
    }
    .nohavepadd {
      position: absolute;
      left: -109px;
      top: -1px;
      background: #fff;
      border-radius: 4px 4px 4px 4px;
      // font-weight: 500;
      // font-size: 12px;
      // color: #333333;

      // .text {
      //   margin-bottom: 7px;
      // }
      .jianttou {
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-left: 8px solid #fff; /* 黑色箭头 */
        // background: #57cc9a;
        position: absolute;
        right: -8px;
        bottom: 50px;
      }
    }
    .nowconercop {
      position: absolute;
      left: -109px;
      top: -1px;
      background: #fff;
      border-radius: 4px 4px 4px 4px;
      // font-weight: 500;
      // font-size: 12px;
      // color: #333333;
      .text {
        height: 100px;
      }
      .jianttou {
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-left: 8px solid #fff; /* 黑色箭头 */
        // background: #57cc9a;
        position: absolute;
        right: -8px;
        bottom: 50%;
      }
    }
  }
}
</style>